<script>
import Form, { formCreate } from '../../../../../../components/form';
import request from '../../../../../../utils/request';

import FrozenDetailTable from './components/frozen_detail_table.vue';

formCreate.component('FrozenDetailTable', FrozenDetailTable);

export default {
  extends: Form,
  props: {
    functionCode: String,
    modalFormData: Object,
  },
  data() {
    return {
      rule: [],
      manualOptions: [],
      detailOptions: [],
      buttons: {
        submit: false,
        close: false,
        loading: false,
        submitAudit: false,
      },
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  async mounted() {
    this.rule = await this.getBeforFormRule('fee_discount_condition_detail_form');
    this.rule.map((v) => {
      const rowData = v;
      if (rowData.field === 'discountDetail') {
        rowData.props = {
          ...rowData.props,
          poolDetailCode: this.modalFormData.poolDetailCode,
          operationType: '',
        };
      }
      rowData.props = {
        ...rowData.props,
        disabled: true,
      };
      if (rowData.field === 'operationType') {
        rowData.props = {
          ...rowData.props,
          disabled: false,
        };
        rowData.on = {
          change: (val) => {
            this.getRule('discountDetail').props.operationType = val;
          },
        };
      }
      return rowData;
    });
    this.reload(this.rule);
    this.getDetailOptions();
    if (this.modalFormData.id) {
      this.getData();
    }
  },
  methods: {
    getData() {
      const path = '/fee/feePoolDetailController/queryByPoolDetailCode';
      request
        .get(path, { poolDetailCode: this.modalFormData.poolDetailCode })
        .then((res) => {
          if (res.success) {
            this.setValue({
              ...res.result,
              operationType: '',
            });
          }
        });
    },
    // 获取明细调整类型
    getDetailOptions() {
      const path = '/fee/feePoolController/getOperationTypeSelectList';
      const params = {
        queryType: '9',
      };
      request
        .get(path, params)
        .then((res) => {
          if (res.success) {
            const operationType = this.getRule('operationType');
            operationType.options = res.result.map((v) => ({
              value: v.value,
              label: v.text,
            }));
          }
        });
    },
  },
};
</script>
